// import AuthGuard from "./auth/AuthGuard";
// import AppLayout from "./components/appLayout/AppLayout";
// import sessionRoutes from "./views/sessions/SessionRoutes";
// import { Navigate } from "react-router-dom";
// import NotFound from "./views/sessions/NotFound";
// import mastersRoutes from "./views/masters/MasterRoutes";
// import { Dashboard, Home } from "@mui/icons-material";

// import UnderDevelopment from "./views/sessions/UnderDevelopment";

// import Discover from "./views/sessions/StartJourney";
// import accountRoutes from "./views/Account/AccountRoutes";
// import hiringRoutes from "./views/Hiring DashBoard/Hiringroutes";
// import appliedRoutes from "./views/Applied Dashboard/appliedRoutes";
// import settingRoutes from "./views/Settings/settingRoutes";
// import ArtiztHomeRoutes from "./views/ArtiztHome/ArtiztHomeRoutes";
// import homeroutes from "./views/Home/HomeRoutes";
// import SavedRoutes from "./views/Saved/SavedRoutes";
// import HomePage from "./views/Home/Home";
// import PrivateRoute from "./PrivateRouter";
// const routes = [
//   {
//     element: (
//       <AuthGuard>
//         <AppLayout />
//       </AuthGuard>
//     ),
//     children: [
//       {
//         path: '/discover',
//         element: (
//           <PrivateRoute>
//             <Discover />
//           </PrivateRoute>
//         ),
//       },

//       { path: '/home', element: <HomePage /> },

//       // spread your route groups
//       ...accountRoutes,
//       ...hiringRoutes,
//       ...appliedRoutes,
//       ...settingRoutes,
//       ...ArtiztHomeRoutes,
//       ...homeroutes,
//       ...SavedRoutes,

//       { path: '*', element: <UnderDevelopment /> },
//     ],
//   },
//   ...sessionRoutes,

//   // default redirect route
//   { path: '/', element: <Navigate to="/session/crea-load-page" /> },

//   // global 404
//   { path: '*', element: <NotFound /> },
// ];

// export default routes;

// // import AuthGuard from "./auth/AuthGuard";
// // import AppLayout from "./components/appLayout/AppLayout";
// // import sessionRoutes from "./views/sessions/SessionRoutes";
// // import { Navigate } from "react-router-dom";
// // import NotFound from "./views/sessions/NotFound";
// // import mastersRoutes from "./views/masters/MasterRoutes";
// // import { Dashboard, Home } from "@mui/icons-material";

// // import UnderDevelopment from "./views/sessions/UnderDevelopment";

// // import LoadPage from "./views/sessions/ConnectLoadPage";
// // import accountRoutes from "./views/Account/AccountRoutes";
// // import hiringRoutes from "./views/Hiring DashBoard/Hiringroutes";
// // import appliedRoutes from "./views/Applied Dashboard/appliedRoutes";
// // import settingRoutes from "./views/Settings/settingRoutes";
// // import ArtiztHomeRoutes from "./views/ArtiztHome/ArtiztHomeRoutes";
// // import homeroutes from "./views/Home/HomeRoutes";
// // import SavedRoutes from "./views/Saved/SavedRoutes";
// // import HomePage from "./views/Home/Home";

// // const routes = [
// //     {
// //       element: (
// //         <AuthGuard>
// //           <AppLayout />
// //         </AuthGuard>
// //       ),
// //       children: [
// //          { path: '/home', element:<HomePage/> },
// //         // ...mastersRoutes,
// //         ...accountRoutes,
// //         ...hiringRoutes,
// //         ...appliedRoutes,
// //         ...settingRoutes,
// //         ...ArtiztHomeRoutes,
// //         ...homeroutes,
// //         ...SavedRoutes,

// //         { path: '*', element: <UnderDevelopment /> },
// //       ],
// //     },
// //     ...sessionRoutes,
// //     // { path: '/', element: <Navigate to="/session/signin" /> },
// //     { path: '/', element: <Navigate to="/session/crea-load-page" /> },
// //     { path: '*', element: <NotFound /> },

// //   ];

// //   export default routes;
import AuthGuard from "./auth/AuthGuard";
import AppLayout from "./components/appLayout/AppLayout";
import sessionRoutes from "./views/sessions/SessionRoutes";
import { Navigate } from "react-router-dom";
import NotFound from "./views/sessions/NotFound";
import mastersRoutes from "./views/masters/MasterRoutes";
import { Dashboard, Home } from "@mui/icons-material";

import UnderDevelopment from "./views/sessions/UnderDevelopment";

import HomePage from "./views/Home/Home";
import accountRoutes from "./views/Account/AccountRoutes";
import hiringRoutes from "./views/Hiring DashBoard/Hiringroutes";
import LanguageRoutes from "./views/Language/LanguageRoutes";
import ProfileRoutes from "./views/MyProfile/ProfileRoutes";
import homeroutes from "./views/Home/HomeRoutes";
import ArtiztHomeRoutes from "./views/ArtiztHome/ArtiztHomeRoutes";
import SavedRoutes from "./views/Saved/SavedRoutes";
import appliedroutes from "./views/Applied DashBoard/appliedRoutes";
import settingRoutes from "./views/Settings/settingRoutes";
import TranslateRoutes from "./views/Translate/TranslateRoutes";
import SubscriptionRoutes from "./views/Subscription/SubscriptionRoutes";
import settingnewoutes from "./views/Settings New/settingsnewRoutes";

const routes = [
  {
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      { path: "/home", element: <HomePage /> },
      // ...mastersRoutes,
      ...accountRoutes,
      ...hiringRoutes,
      ...homeroutes,
      ...ArtiztHomeRoutes,
      ...SavedRoutes,
      ...appliedroutes,
    ...settingRoutes,
      ...TranslateRoutes,
   ...SubscriptionRoutes,
  // ...settingnewoutes,

      { path: "*", element: <UnderDevelopment /> },
    ],
  },
      ...sessionRoutes,
      ...LanguageRoutes,
      ...ProfileRoutes,
   { path: '/', element: <Navigate to="/session/signinew" /> },
  { path: "/", element: <Navigate to="/session/crea-load-page" /> },
  { path: "*", element: <NotFound /> },
];

export default routes;


